import { notEmpty } from "@product/scmp-sdk";
import { useTimeoutEffect } from "@react-hookz/web";
import { differenceInMilliseconds } from "date-fns";
import { useAtom } from "jotai";
import { useMemo } from "react";
import { registerEmailCookieAtom } from "shared/lib/account";
export const useRegisterEmailExpirationEffect = () => {
  const [{
    expirationDate
  }, updateRegisterEmailCookie] = useAtom(registerEmailCookieAtom);

  /**
   * trigger the timeout
   * when the expirationDate local storage value and registerEmail cookie value exist
   */
  const delay = useMemo(() => notEmpty(expirationDate) ? differenceInMilliseconds(new Date(expirationDate), new Date()) : undefined, [expirationDate]);
  useTimeoutEffect(() => {
    updateRegisterEmailCookie(null);
  }, delay);
};